module.exports = __webpack_public_path__ + "static/img/2.2ac50557.png";